import ConfirmModal from "../../../confirmViewModal/ConfirmModal";
import { VERSION_DETAILS_COPY } from "../constants/versionDetails.constants";
import { VersionHistoryGroup } from "../types/versionHistory.types";
import { resolveVersionLabel } from "../utils/versionHistory.utils";

interface DeleteVersionDetailsDialogProps {
  version: VersionHistoryGroup | null;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Confirms clearing a version's Year / Number of units / Price per unit before the API call fires. */
export const DeleteVersionDetailsDialog = ({ version, isDeleting, onConfirm, onCancel }: DeleteVersionDetailsDialogProps) => {
  const label = resolveVersionLabel(version);

  return (
    <ConfirmModal
      viewModal={!!version}
      closeModal={onCancel}
      cancel={onCancel}
      approve={onConfirm}
      title={VERSION_DETAILS_COPY.deleteDialogTitle}
      subTitle={version ? VERSION_DETAILS_COPY.deleteDialogBody(label) : ""}
      confirmText={VERSION_DETAILS_COPY.deleteConfirm}
      variant="destructive"
      isLoading={isDeleting}
      testId="delete-version-details-dialog"
    />
  );
};
